module.exports = __webpack_public_path__ + "media/01.2bc40ddd.mp3";